import { render, staticRenderFns } from "./HealthyLife.vue?vue&type=template&id=7a329e9b&scoped=true&"
import script from "./HealthyLife.vue?vue&type=script&lang=js&"
export * from "./HealthyLife.vue?vue&type=script&lang=js&"
import style0 from "./HealthyLife.vue?vue&type=style&index=0&id=7a329e9b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a329e9b",
  null
  
)

export default component.exports